/**
 * Asset type values
 */
export enum AssetTypeEnum {
	VEHICLE = 'vehicle',
	VEHICLE_CATEGORY = 'vehicle_category',
	EQUIPMENT = 'equipment',
	SERVICES = 'services',
	OTHER = 'other',
}
